<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  var pc_h5__route = [
        {
          pc: "/",
          h5: "/",
        },
        {
          pc:'/',
          h5:'/home'
        },
        {
          pc: "login",
          h5: "/login",
        },
        {
          pc: "Forgot_password",
          h5: "/forget_password",
        },
        {
          pc: "/about",
          h5: "",
        },
        {
          pc: "personal_center",
          h5: "/my",
        },
        {
          pc: "ordermanage", 
          h5: "/ordermessage",
        },
        {
          pc: "orderdetails",
          h5: "/order_details",
        },
        {
          pc:'',
          h5:'/case_sharing'
        },
        {
          pc:'',
          h5:'/design_material'
        },
        {
          pc:'',
          h5:'/invoicing'
        },
        {
          pc:'',
          h5:'/invoicing_apply'
        },
        {
          pc:'',
          h5:'/invoicing_order'
        },
        {
          pc:'',
          h5:'/invoicing_details'
        },
        {
          pc:'',
          h5:'/daily_detail'
        },
        {
          pc:'',
          h5:'/cancel_order'
        },
        {
          pc:'',
          h5:'/news_details'
        },
        {
          pc:'',
          h5:'/order_operation'
        },
        {
          pc: "personalinfo",
          h5: "/personal_data",
        },
        {
          pc: "changepassword",
          h5: "/update_password",
        },
        {
          pc: "defaultinvoice",
          h5: "/invoiceInfo",
        },
        {
          pc: "mycourses",
          h5: "",
        },
        {
          pc: "notification",
          h5: "/news",
        },
        {
          pc: "clouddesignsolution",
          h5: "",
        },
        {
          pc: "dailymanage",
          h5: "/daily_manage",
        },
        {
          pc: "dailycreate",
          h5: "/create_daily",
        },
        {
          pc: "financialmanage",
          h5: "/financial_management",
        },
        {
          pc: "technical_services",
          h5: "/technical_services",
        },
        {
          pc: "smart_lighting",
          h5: "/",
        },
        {
          pc: "product_detail",
          h5: "/product_details",
        },
        {
          pc: "smart_product",
          h5: "/smart_lighting",
        },
        {
          pc: "case_details",
          h5: "/case_details",
        },
        {
          pc: "training_services",
          h5: "",
        },
        {
          pc: "coursed_details",
          h5: "",
        },
        {
          pc: "aboutUs",
          h5: "",
        },
        {
          pc: "aboutIntroduce",
          h5: "",
        },
        {
          pc: "sign_up",
          h5: "",
        },
        {
          pc: "searchResults",
          h5: "",
        },
        {
          pc: "cloudDesign",
          h5: "",
        },
        {
          pc: "helpDetails",
          h5: "",
        },
        {
          pc: "helpDetails",
          h5: "",
        },
        {
          pc:'',
          h5: "/agreement",
        }
      ];

      var route = document.location.pathname;

      var is_mobile = isMobile();

      // 协议 域名 端口

      var urlParmas = `${document.location.protocol}//${document.domain}${
        document.location.port ? ":" + document.location.port : ""
      }`;

    // 路由
    var len = pc_h5__route.length;
  export default {
    name: "app",
    data() {
      return {
      }
    },
    created(){
      // console.log('执行')

      // let checkIE = checkIe();
      // if (checkIE != -1) {
      //   alert("请使用主流浏览器如谷歌浏览器、Edge浏览器");
      // }

    },
    mounted(){
      if (is_mobile) {
          check_h5()

        } else {
          check_pc()

        }

    },
    watch: {

    },
    beforeDestroy() { }, //生命周期 - 销毁之前
    beforeRouteEnter(to, from, next) {
      next();
    },
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    //方法集合
    methods: {

    },
    created() {
    }
  };


  // pc 
  function check_pc () {
  // 直接首页访问
  if (route == "/" || route == '/_mo_') {
      urlParmas += "/_dp_" + document.location.search;
      // window.location.replace(urlParmas)
      locationReplace(urlParmas)
      return;
  }
  // pc router usit
  if (route.match(/\/_dp_/))  {
    var param = `${route.replace("/_dp_", "")}${document.location.search}`;
      urlParmas += `/_dp_?post_name=${encodeURIComponent(param)}`;
      // window.location.replace(urlParmas)
      locationReplace(urlParmas)
    return
  }

  // h5 router usit
  if (route.match(/\/_mo_/)) {
    for (var i = 0; i < len; i++) {
      // 页面路径
      if (
        route.indexOf(pc_h5__route[i].h5) != -1 &&
        pc_h5__route[i].h5.length > 2
      ) {
        // h5存在此页面路径
        if (pc_h5__route[i].pc) {
          var param = `${pc_h5__route[i].pc}${document.location.search}`;

          // 跳转
          urlParmas += `/_dp_?post_name=${encodeURIComponent(param)}`;
          // window.location.replace(urlParmas)
          locationReplace(urlParmas)
        } else {
          // pc不存在 跳h5
          // urlParmas += `${route}${document.location.search}`;
          // window.location.replace(urlParmas)
          urlParmas += "/_dp_";
          // window.location.replace(urlParmas)
          locationReplace(urlParmas)
        }
        break;
        // 用 h5链接访问 h5
      }
    }

    return
  }
  
  if (!route.match(/\/_mo_/) && !route.match(/\/_dp_/)) {
      urlParmas += "/_dp_";
      // window.location.replace(urlParmas);
      locationReplace(urlParmas)
    return
  }

}
  // h5
function check_h5 () {
  //首页
  if (route == "/" || route == '/_dp_') {
    urlParmas += "/_mo_" +document.location.search;
    // window.location.replace(urlParmas);
    locationReplace(urlParmas)
    return;
  }

  // h5 router usit
  if (route.match(/\/_mo_/)) {
    var param = `${route.replace("/_mo_", "")}${document.location.search}`;
      urlParmas += `/_mo_?post_name=${encodeURIComponent(param)}`;
      // window.location.replace(urlParmas);
      locationReplace(urlParmas)
    return
  }


    // pc router usit
    if (route.match(/\/_dp_/)) {

      for (var i = 0; i < len; i++) {
      // 页面路径
      if (
        route.indexOf(pc_h5__route[i].pc) != -1 &&
        pc_h5__route[i].pc.length > 2
      ) {
        // h5存在此页面路径
        if (pc_h5__route[i].h5) {
          var param = `${pc_h5__route[i].h5}${document.location.search}`;

          // 跳转
          urlParmas += `/_mo_?post_name=${encodeURIComponent(param)}`;
          // window.location.replace(urlParmas);
          locationReplace(urlParmas)
        } else {
          // h5 不存在 跳pc
          // urlParmas += `${route}${document.location.search}`;
          // window.location.replace(urlParmas)
          urlParmas += "/_mo_";
          // window.location.replace(urlParmas);
          locationReplace(urlParmas)
        }
        break;
        // 用 h5链接访问 h5
      }
    }

      return
    }

    if (!route.match(/\/_mo_/) && !route.match(/\/_dp_/)) {
      urlParmas += "/_mo_";
      // window.location.replace(urlParmas);
      locationReplace(urlParmas)
    return
  }

}
function isMobile() {
  var mobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return mobile != null;
}

function locationReplace(url){
  // location.replace(url);
  if(history.replaceState){
    history.replaceState(null, document.title, url);
    history.go(0);
  }else{
    location.replace(url);
  }
}
function checkIe() {
  // if (document.documentMode) return document.documentMode;
  let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  let isIE =
    userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
  let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
  let isIE11 =
    userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    let fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return 7;
    } else if (fIEVersion == 8) {
      return 8;
    } else if (fIEVersion == 9) {
      return 9;
    } else if (fIEVersion == 10) {
      return 10;
    } else {
      return 6; //IE版本<=7
    }
  } else if (isEdge) {
    return "edge"; //edge
  } else if (isIE11) {
    return 11; //IE11
  } else {
    return -1; //不是ie浏览器
  }
}

</script>
<style lang="less">

</style>